module.exports = __webpack_public_path__ + "static/media/healthy-breakfast1000.e2cbfcdb.jpeg";